import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React from 'react';
import { css, styled } from 'styled-components';
import { resets } from '../utils/index.js';
import 'polished';
import { allStates } from '../../utils/css/pseudo.js';
import '@babel/runtime/helpers/typeof';

var aResets = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  display: inline;\n  text-decoration: underline;\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  display: inline;\n  text-decoration: underline;\n"])), resets.normalize.html, resets.normalize.a, resets.common, allStates('color: inherit; text-decoration: underline; cursor: pointer;'));
var Ahref = styled.a.withConfig({
  componentId: "sc-1tv0rhd-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), aResets);
var HtmlA = function HtmlA(_a) {
  var forwardedRef = _a.forwardedRef,
    passProps = __rest(_a, ["forwardedRef"]);
  return /*#__PURE__*/React.createElement(Ahref, __assign({
    ref: forwardedRef
  }, passProps));
};
var templateObject_1, templateObject_2;

export { HtmlA };
//# sourceMappingURL=HtmlA.js.map
